import { useCallback, useMemo } from 'react';

import _ from 'lodash';

import { Permissions } from 'src/app_deprecated/constants/PermissionsConstants';

import {
  useMarketingCampaignsSharedActionModals,
  ActionType,
} from 'src/app/pages/marketing/campaigns/list/shared-actions/marketing-campaigns-shared-action-modals';
import { usePermissionCheck } from 'src/app/state/user-permissions';

import type { BulkAction } from 'src/app/components/lib/table';

export function useBulkActions(): BulkAction[] {
  const { setActionModal, setSelectedItems } = useMarketingCampaignsSharedActionModals();

  const canCreateEditOrSendCampaigns = usePermissionCheck(
    [Permissions.CreateEditCampaigns, Permissions.SendCampaigns],
    'or'
  );

  const handleOnAction = useCallback(
    (action: ActionType, selectedRows: any[]) => {
      setSelectedItems(selectedRows);
      setActionModal(action);
    },
    [setActionModal, setSelectedItems]
  );

  const baseActions = useMemo(
    () =>
      [
        {
          label: 'Edit tags',
          id: 'edit-tags',
          visible: canCreateEditOrSendCampaigns,
          action: (selectedRows) => handleOnAction(ActionType.EditTags, selectedRows),
        },
      ].map((action) => ({
        ...action,
        automationId: `campaigns-bulk-action-${action.label.toLowerCase().split(' ').join('-')}`,
      })),
    [canCreateEditOrSendCampaigns, handleOnAction]
  );

  return baseActions;
}
